import { Button, Dropdown, Space, Typography } from "antd"
import { DownOutlined, FileImageOutlined } from "@ant-design/icons"
import ShowSavedPricesDrawer from "../../../components/Manager/Prices/ShowSavedPricesDrawer"
import OrderHistory from "../../../components/Manager/Prices/OrderHistory"
import PriceOffer from "../../../components/Manager/PriceOffer/PriceOffer"
import DuplicatePrice from "./DuplicatePrice"

const { Link } = Typography

export default function PriceActions({ record }) {
  const items = [
    {
      key: "details",
      label: <ShowSavedPricesDrawer data={record} />,
    },
    {
      key: "history",
      label: <OrderHistory price={record} />,
    },
    {
      key: "generate",
      label: <PriceOffer data={record} />,
    },
    {
      key: "duplicate",
      label: <DuplicatePrice record={record} />,
    },
    {
      key: "picture",
      label: record.product?.productFileUrl ? (
        <Link type="text" rel="noreferrer" target="_blank" href={record.product.productFileUrl}>
          <FileImageOutlined /> View Image
        </Link>
      ) : (
        <span style={{ color: "#999" }}>
          {" "}
          <FileImageOutlined />
          No Picture
        </span>
      ),
    },
  ]

  return (
    <Dropdown menu={{ items }} trigger={["click"]} placement="bottomRight">
      <Button size="small">
        <Space>
          Actions
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  )
}
